// src/hooks/plan/useProgressPage.js
import { useState, useMemo, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import planApi from '@api/planApi';
import { normalizePage } from '@utils/paging';
import { AuthContext } from '@context/AuthContext';

export default function useProgressPage() {
  const { auth } = useContext(AuthContext);
  const [filters, setFilters] = useState({ 
      assignee: '', 
      companyName: '', 
      status: '', 
      searchYear: new Date().getFullYear().toString(), 
      pageNum: 1, 
      pageSize: 10 
  });
  const [selectedBiz, setSelectedBiz] = useState(null);

  // 1. 요약 목록 조회
  const summaryQuery = useQuery({
    queryKey: ['plan', 'progress', 'summary', filters],
    queryFn: () => planApi.listProgressSummary(filters),
    keepPreviousData: true,
  });

  const page = useMemo(() => normalizePage(summaryQuery.data) || { rows: [], total: 0, pageNum: 1, pageSize: 10 }, [summaryQuery.data]);

  // 2. 상세 내역 조회
  const detailQuery = useQuery({
    queryKey: ['plan', 'progress', 'details', selectedBiz?.bizMgtNo, selectedBiz?.staffId],
    queryFn: () => planApi.listProgressDetails(selectedBiz.bizMgtNo, selectedBiz.staffId),
    enabled: !!selectedBiz, 
  });

  // 🌟 (핵심 수정) API 응답 구조에 맞게 배열 데이터 안전 추출
  const detailData = detailQuery.data?.data !== undefined ? detailQuery.data.data : detailQuery.data;
  const detailList = Array.isArray(detailData) ? detailData : [];

  const onSearch = () => { setFilters(p => ({ ...p, pageNum: 1 })); };

  return {
    filters, setFilters, page, onSearch,
    selectedBiz, setSelectedBiz,
    detailList, 
    detailLoading: detailQuery.isFetching,
    auth
  };
}